import { cx } from "@/utils";
import {
  HoverCard as RadixHoverCard,
  HoverCardArrow,
  HoverCardContent,
  HoverCardProps as RadixHoverCardProps,
  HoverCardTrigger,
} from "@radix-ui/react-hover-card";

import styles from "./HoverCard.module.css"; // Import your CSS file with theme variables

type HoverCardProps = {
  content: React.ReactNode;
  padding?: boolean;
} & RadixHoverCardProps;

const HoverCard = ({
  children,
  content,
  padding = true,
  ...props
}: HoverCardProps) => {
  return (
    <RadixHoverCard {...props}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="center"
        className={cx(styles.content, { [styles.pad]: padding })}
      >
        <HoverCardArrow className={styles.arrow} />
        {content}
      </HoverCardContent>
    </RadixHoverCard>
  );
};

export default HoverCard;
